import locale from "localization";

export const depositTypeOptions = [
  { label: locale.fuelAndLubesSales, value: locale.fuelAndLubesSales },
  { label: locale.lpgSales, value: locale.lpgSales },
  { label: locale.lubeserv, value: locale.lubeserv },
  { label: locale.keyAccountPayments, value: locale.keyAccountPayments },
  { label: locale.revolvingFund, value: locale.revolvingFund },
  { label: locale.consumableFund, value: locale.consumableFund },
  { label: locale.specialRequest, value: locale.specialRequest },
  { label: locale.customerRefundableDeposit, value: locale.customerRefundableDeposit },
];
